exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-radio-image[data-v-3f06a60a]{display:flex}.setting-radio-image li[data-v-3f06a60a]{margin-right:30px;max-width:150px}.setting-radio-image li img[data-v-3f06a60a]{max-width:100%}.setting-radio-image label[data-v-3f06a60a]{opacity:.5;transition:all .3s ease}.setting-radio-image input[type=radio][data-v-3f06a60a]{display:none}.setting-radio-image input[type=radio]:checked~label[data-v-3f06a60a]{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f06a60a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/fields/radio-image.vue
// module id = 81
// module chunks = 0